import React, { Component } from "react";
import AxiosApi from "../../../Api";
import { ToastContainer, toast } from "react-toastify";
import "../uploader.css";
import "../uploader2.css";
import ClipLoader from "react-spinners/ClipLoader";

export class FileUpload extends Component {
  constructor(props) {
    super(props);
    this.fileDownloaddHandler = this.fileDownloaddHandler.bind(this);
    this.state = {
      selectedFile: null,
      resFileName: "",
      showUploadButton: "fresh-button",
      showDownloadButton: "fresh-button hide_data",
      email: this.props.email,
      loading: false,
      exitFlag: false,
      loadPercentage: 0,
    };
  }

  onChangeHandler = (event) => {
    var file = event.target.files;
    if (this.validateSize(event)) {
      this.setState({
        selectedFile: file,
      });
    }
  };
  fileDownloaddHandler = () => {
    var data = this.state;
    console.log(data);
    AxiosApi
      .request({
        url: process.env.REACT_APP_API_ROOT_URL_PREFIX + "/api/upload/res",
        method: "Post",
        data,
        responseType: "arraybuffer",
      })

      .then((response) => {
        console.log(response);
        //////////////////new code
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "download.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        this.props.closePopup();
      });

    this.setState({
      resFileName: "",
      showDownloadButton: "fresh-button hide_data",
      showUploadButton: "fresh-button",
    });
  };

  fileUploadHandler = (call) => {
    const data = new FormData();
    if (this.state.selectedFile === null) {
      const err = "No Files selected";
      toast.error(err);
    } else {
      for (var x = 0; x < this.state.selectedFile.length; x++) {
        data.append("file", this.state.selectedFile[x]);
      }
      this.setState({
        showUploadButton: "fresh-button hide_data",
        loading: true,
      })
      AxiosApi
        .post(`${process.env.REACT_APP_API_ROOT_URL_PREFIX}/api/${call}`, data, {
          headers: { email: this.state.email },
        })
        .then((res) => {
          // then print response status
          console.log("Response Received");
          toast.info(
            "File is uploaded & under processing. We'll notify you once it's ready."
            , { toastId: 'uploading' });
          this.setState({
            resFileName: res.data,
            loading: false
          });
          var t = 0;
          //this.WaitForUpload(res.data, t);
        })
        .catch((error) => {
          console.error("There was an error in uploading data !", error);
          toast.error("Error in uploading, please try again");
        });
    }
  };

  async WaitForUpload(filename, t) {
    var outfile = { outfile: filename };
    await AxiosApi
      .post(process.env.REACT_APP_API_ROOT_URL_PREFIX + "/api/upload/status", outfile)
      .then((response) => {
        console.log('response======>', response);
        if (response.data[0].Upload_Status === "Completed") {
          toast.success(
            "File processed successfully! Please download the Response."
            , { autoClose: 5000 });
          toast.dismiss('uploading');
          this.setState({
            loading: false,
            showDownloadButton: "fresh-button",
          });
        } else {
          setTimeout(() => {
            // if (t <= 1000) {
            t++;
            // console.log(t);
            var percentage =
              (response.data[0].Completed_Rows / response.data[0].Max_Rows) *
              100;
            percentage = Math.round(percentage);
            this.setState({
              loadPercentage: percentage,
            });
            this.WaitForUpload(filename, t);
            // } else {
            //   console.log("timeout reached");
            //   this.setState({
            //     loading: false,
            //     showDownloadButton: "fresh-button",
            //   });
            //   toast.error("Application Timed Out");
            // }
          }, 500000);
        }
      })
      .catch((error) => {
        console.error(
          "There was an error in fetching upload status data !",
          error
        );
        this.WaitForUpload(filename, t);
      });
  }

  validateSize = (event) => {
    let file = event.target.files;
    let size = 300000000;
    let err = "";

    if (file.length === 0) {
      err = "No Files selected";
      toast.error(err);
    } else {
      for (var x = 0; x < file.length; x++) {
        if (file[x].size > size) {
          err = file[x].type + "is too large, please pick a smaller file\n";
          toast.error(err);
        }
      }
    }
    if (err !== "") {
      event.target.value = null;
      console.log(err);
      return false;
    }
    return true;
  };

  render() {
    const Filler = (props) => {
      return (
        <div className="filler" style={{ width: `${props.percentage}%` }} />
      );
    };
    const ProgressBar = (props) => {
      return (
        <div className="progress-bar-1">
          <Filler percentage={props.percentage} />
        </div>
      );
    };

    return (
      <div className="popup">
        <div className="popup_inner">
          <div className="container">
            <div style={{ justifyContent: 'space-between', margin: '15px' }} className="row">
              <div className="col-md-1"></div>
              <div className="col-md-1"></div>
              <div className="col-md-6 text-center">
                <form method="post" action="#" id="#">
                  <div className="form-group files">
                    <label>
                      {" "}
                      <h4>Upload Your File</h4>{" "}
                    </label>
                    <input
                      type="file"
                      name="file"
                      multiple
                      className="form-control"
                      onChange={this.onChangeHandler}
                    />
                  </div>
                  <div className="col-md-12 pull-right">
                    <button
                      style={{ width: '140px' }}
                      width="100%"
                      type="button"
                      // className="fresh-button hide_data"
                      className={this.state.showUploadButton}
                      onClick={() => this.fileUploadHandler('upload')}
                    >
                      Upload File anas test
                    </button>

                    <button
                      style={{ width: '140px' }}
                      width="100%"
                      type="button"
                      // className="fresh-button hide_data"
                      className={this.state.showUploadButton}
                      onClick={() => this.fileUploadHandler('skufilterData')}
                    >
                      Upload SKU File
                    </button>

                    {this.state.loading ? (
                      <ClipLoader loading={this.state.loading} />
                    ) : (
                      <button
                        width="100%"
                        type="button"
                        className={this.state.showDownloadButton}
                        onClick={this.fileDownloaddHandler}
                      >
                        Download Response
                      </button>
                    )}
                    {this.state.loading && (
                      <ProgressBar percentage={this.state.loadPercentage} />
                    )}
                  </div>
                </form>
              </div>
              <div className="col-md-1">
                {" "}
                <button
                  width="100%"
                  type="button"
                  className="btn btn-danger"
                  onClick={this.props.closePopup}
                >
                  X
                </button>
              </div>
              <div className="col-md-1"></div>
            </div>
            <ToastContainer
              position="top-right"
              autoClose={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss={false}
              draggable
            ></ToastContainer>
          </div>
        </div>
      </div>
    );
  }
}

export default FileUpload;
